import * as actionTypes from './actiontypes';
import * as API from './api';
import { getCurrentChatHistory } from '../history_details/api';
import { log } from '../../config/utils'

export const updateUsersState = (payload, path) => {
    return {
        type: actionTypes.UPDATE_USERS_STATE,
        payload,
        path
    };
}

export const getUsersListAndColumns = (payload, viewUserProfile) => {
    return dispatch => {
        dispatch({
            type: actionTypes.USERS_AND_COLUMNS_LOADING,
        });
        API.getUsersList(payload, (error, response) => {
            if (!error && response && response.data) {
                dispatch({
                    type: actionTypes.USERS_AND_COLUMNS_LOADED,
                    payload: response.data,
                    viewUserProfile
                });
            } else {
                dispatch({
                    type: actionTypes.USERS_AND_COLUMNS_LOAD_ERROR,
                });
            }
        });
    };
}

export const getUsersList = (payload, callback) => {
    return dispatch => {
        dispatch({
            type: actionTypes.USERS_LOADING,
        });

        API.getUsersList(payload, (error, response) => {
            if (!error && response && response.data) {
                dispatch({
                    type: actionTypes.USERS_LOADED,
                    payload: response.data,
                });
                if (callback) callback();
            } else {
                dispatch({
                    type: actionTypes.USERS_LOAD_ERROR,
                });
            }
        });
    };
}

export const getUserBasicInfo = payload => {
    return dispatch => {
        dispatch({
            type: actionTypes.USER_INFO_LOADING,
        });

        API.getUserBasicInfo(payload, (error, response) => {
            if (!error && response && response.data) {
                dispatch({
                    type: actionTypes.USER_INFO_LOADED,
                    payload: response.data,
                });
            } else {
                dispatch({
                    type: actionTypes.USER_INFO_LOAD_ERROR,
                });
            }
        });
    };
}

export const getUserStats = (payload, callback) => {
    return dispatch => {
        dispatch({
            type: actionTypes.USER_STATS_LOADING_START,
        });

        API.getUserStats(payload, (error, response) => {
            dispatch({
                type: actionTypes.USER_STATS_LOADING_END,
            });
            if (!error && response && response.data) {
                dispatch({
                    type: actionTypes.USER_STATS_LOADED,
                    payload: response.data,
                });
                if (callback) callback();
            }
        });
    };
}

export const getUserEventHistogram = payload => {
    return dispatch => {
        dispatch({
            type: actionTypes.USER_EVENT_HISTOGRAM_LOADING,
        });

        API.getUserEventHistogram(payload, (error, response) => {
            if (!error && response && response.data) {
                dispatch({
                    type: actionTypes.USER_EVENT_HISTOGRAM_LOADED,
                    payload: response.data,
                });
            } else {
                dispatch({
                    type: actionTypes.USER_EVENT_HISTOGRAM_LOAD_ERROR,
                });
            }
        });
    };
}

export const getChatlogListFilters = () => {
    return dispatch => {
        API.getChatlogListFilters({}, (error, response) => {
            if (!error && response && response.data) {
                dispatch({
                    type: actionTypes.CHATLOG_LIST_FILTERS_LOADED,
                    payload: response.data,
                });
            }
        });
    };
}

export const getUserChatlogList = payload => {
    return dispatch => {
        if(payload && payload.skip === 0){
            dispatch({
                type: actionTypes.USER_CHATLOG_LIST_LOADING_START,
            });
        }
        API.getUserChatlogList(payload, (error, response) => {
          log('getUserChatlogList response', response)
            dispatch({
                type: actionTypes.USER_CHATLOG_LIST_LOADING_END,
            });
            if (!error && response && response.data) {
                if (payload && payload.skip > 0) {
                    dispatch({
                        type: actionTypes.MORE_USER_CHATLOG_LIST_LOADED,
                        payload: response.data,
                    });
                } else {
                    dispatch({
                        type: actionTypes.USER_CHATLOG_LIST_LOADED,
                        payload: response.data,
                    });
                }
            } else if (payload && payload.skip === 0) {
                dispatch({
                    type: actionTypes.USER_CHATLOG_LIST_LOAD_ERROR,
                });
            }
        });
    };
}

export const getActiveChatlogDetails = (chatlog_item) => {
    const payload = { sessionId: chatlog_item.sessionId };
    return dispatch => {
        dispatch({
            type: actionTypes.ACTIVE_CHATLOG_DETAILS_LOADING,
        });
        getCurrentChatHistory(payload, (error, response) => {
            if (!error && response) {
                dispatch({
                    type: actionTypes.ACTIVE_CHATLOG_DETAILS_LOADED,
                    payload: response,
                    chatlog_item
                });
            } else {
                dispatch({
                    type: actionTypes.ACTIVE_CHATLOG_DETAILS_LOAD_ERROR,
                });
            }
        });
    };
}


// WEBPACK FOOTER //
// ./src/data/redux/users_details/actions.js